import React, { Component } from "react";

export class PayoutModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.PayoutModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, show, onClose, modalSize, errorMessage, viewmode } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
      >
        <AppFormData
          {...attrs}
          onClose={onClose}
          errorMessage={errorMessage}
          viewmode={viewmode}
          size={100}
        ></AppFormData>
      </AppCanvas>
    );
  }
}

export default PayoutModal;
